




























































import { Component, Vue } from 'vue-property-decorator'
import { OptionItemType, TableColumnItemType, OperationItemType } from '../../types/type'
import { Pagination } from '../../mixins/pagination'
@Component({
  name: 'CanteenIndexConfig',
  mixins: [Pagination],
  components: {
    'concise-card': () => import('../../components/common/conciseCard.vue'),
    'loading-container': () => import('../../components/loading.vue'),
    'table-module': () => import('../../components/common/tableModule.vue')
  }
})
export default class CanteenIndexConfig extends Vue {
  public loading: boolean = false
  // 枚举选项：
  public indexConfigFileTypeOptions: OptionItemType[] = [
    {
      name: '通知公告',
      value: 'INFORM_ANNOUNCEMENT'
    },
    {
      name: '政策文件',
      value: 'POLICY_FILE'
    }
  ]
  public indexConfigFileType: string = 'INFORM_ANNOUNCEMENT'
  // 列表列有哪些：
  public tableColumnList: Array<TableColumnItemType> = [
    {
      title: '发送单位',
      key: 'organizationName',
      type: 'text',
      showStateForTableHeader: 'unilaminar',
      width: '200px'
    },
    {
      title: '类型',
      key: 'typeFordisposeInCanteenIndexConfig',
      type: 'text',
      showStateForTableHeader: 'unilaminar',
      width: '150px',
      needTransformForResult: 'enum'
    },
    {
      title: '标题',
      key: 'title',
      type: 'text',
      showStateForTableHeader: 'unilaminar',
      width: '200px'
    },
    {
      title: '内容',
      key: 'textDetail',
      type: 'richText',
      showStateForTableHeader: 'unilaminar',
      width: '500px'
    },
    {
      title: '附件',
      key: 'otherInfo',
      type: 'file',
      showStateForTableHeader: 'unilaminar',
      width: '300px'
    }
  ]
  // 列表每一行的操作有哪些：
  public columnOperationList: Array<OperationItemType> = [
    {
      title: '详情',
      key: 'detail',
      type: 'primary',
      size: 'mini'
    },
    {
      title: '编辑',
      key: 'update',
      type: 'primary',
      size: 'mini'
    },
    {
      title: '删除',
      key: 'delete',
      type: 'danger',
      size: 'mini'
    }
  ]

  async mounted () {
    this.getTableDataList()
  }

  operationOfAddOrUpdate (id) {
    this.$router.push({
      name: 'AddOrUpdateCanteenIndexConfig',
      query: {
        id
      }
    })
  }

  operationOfGoDetail (id) {
    this.$router.push({
      name: 'CanteenIndexConfigDetail',
      query: {
        id
      }
    })
  }

  // 操作按钮：
  operationForButton ({ key }, { id }) {
    switch (key) {
      case 'detail':
        this.operationOfGoDetail(id)
        break
      case 'update':
        this.operationOfAddOrUpdate(id)
        break
      case 'delete':
        this.operationForDelete(id)
        break
    }
  }

  // 删除：
  operationForDelete (id: string) {
    this
      .$confirm('确定要删除此首页配置项吗?', '提示', {
        confirmButtonText: '确定删除',
        cancelButtonText: '取消删除',
        type: 'error'
      })
      .then(async () => {
        let { data: result } = await (this as any).$http.newAnnouncementRemoveById(id)
        if (result.code !== 200) return this.$message.error(result.msg)
        this.$message.success('删除成功！')
        this.getTableDataList()
      })
      .catch(() => {})
  }

  async getTableDataList () {
    try {
      const _that: any = this
      this.loading = true
      const pageParams = {
        pageNo: _that.currentPage,
        pageSize: _that.pageSize
      }
      const searchParams = {
        type: this.indexConfigFileType
      }
      const params = {
        ...pageParams,
        ...searchParams,
        module: 'CANTEEN_MODULE'
      }
      const { data: result } = await (this as any).$http.newAnnouncementListPage(params)
      this.loading = false
      if (result.code !== 200) return this.$message.error(result.msg)
      _that.tableDataList = ((result.data && result.data.records) || []).map(item => {
        item['typeFordisposeInCanteenIndexConfig'] = item.type
        return item
      })
      _that.total = result.data.total
    } catch (err) {
      console.log(err)
    }
  }

  indexConfigFileTypeChange () {
    let _that: any = this
    _that.currentPage = 1
    _that.pageSize = 10
    this.getTableDataList()
  }
}
